export const notifications = state => state.notifications.items
export const unreadNotificationCount = state => state.notifications.unreadCount
export const unreadNotifications = state => _.filter(notifications(state), (notification) => notification.read_at == null)
export const notificationById = state => id => _.find(notifications(state), { id })


export const notificationsByIds = state => ids => {
    return _.reduce(ids, (res, id) => {
        let notification = notificationById(state)(id)
        if (notification) res.push(notification)
        return res
    }, [])
}

